export default "__VITE_ASSET__CJH7cw$A__"